var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c("h2", { class: _vm.bemElement("title") }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$msg("product.complement.selector.title", "customizer")
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.bemElement("filters") },
        _vm._l(_vm.complementProducts, function(set, index) {
          return _c(
            "button",
            {
              key: set.productName + "-" + index,
              class: _vm.bemElement("filter-button", {
                selected: set.productName === _vm.selectedFilter
              }),
              on: {
                click: function($event) {
                  return _vm.selectFilter($event, set.productName)
                }
              }
            },
            [
              !!_vm.getColorImage(set)
                ? _c("img", {
                    class: [
                      _vm.bemElement("swatch-img"),
                      {
                        loading: _vm.loadingImage
                      }
                    ],
                    attrs: {
                      set: (_vm.image = _vm.getColorImage(set)),
                      alt: _vm.image.alt,
                      src: _vm.image.url
                    },
                    on: {
                      error: _vm.handleImageError,
                      load: function($event) {
                        _vm.loadingImage = false
                      }
                    }
                  })
                : _vm._e(),
              _vm._v("\n      " + _vm._s(set.productName) + "\n    ")
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "productsContainer", class: _vm.bemElement("products") },
        _vm._l(_vm.complementProducts, function(set, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: set.productName === _vm.selectedFilter,
                  expression: "set.productName === selectedFilter"
                }
              ],
              key: index,
              class: _vm.bemElement("product-set"),
              style: _vm.calculateGridColumns(set.individualProducts)
            },
            _vm._l(set.individualProducts, function(product, i) {
              return _c("TheProductCustomizerComplement", {
                key: product.id + "-" + i,
                attrs: { product: product, reset: _vm.reset }
              })
            }),
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("BaseProgressBar", {
        attrs: { container: _vm.$refs.productsContainer }
      }),
      _vm._v(" "),
      _c("p", { class: _vm.bemElement("message") }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.customizerId === "designer"
                ? _vm.$msg("designer.complement.selector.info", "customizer")
                : _vm.$msg("customizer.complement.selector.info", "customizer")
            ) +
            "\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }